import React, { useState } from "react";
import { View, Text } from "react-native";

import { OTHER_TEXT_MAX_LENGTH } from "consts";
import {
  FullscreenInput,
  MediaTray,
  MediaPreview,
  CameraButton,
  AudioButton,
  TextInput,
} from "components";
import { getAddedFiles } from "state/modules/response/selectors";

import { styles } from "./styles";

const BaseOtherText = props => {
  const {
    lang,
    option,
    selectedOption,
    onChangeText,
    onCapture,
    removeFile,
    scrollToEnd,
    containerStyle,
  } = props;

  const value = selectedOption?.other_text || "";

  const { allow_photo, allow_video, allow_audio } = option;
  const [audioEnabled, enableAudio] = useState(false);
  const { mediaFiles, audioFile } = getAddedFiles(selectedOption, option);
  const hasMedia = allow_photo || allow_video || allow_audio;

  const onEnableAudio = () => {
    if (!audioEnabled) {
      setTimeout(scrollToEnd, 50);
    }
    enableAudio(!audioEnabled);
  };

  return (
    <>
      <View style={[containerStyle, hasMedia && styles.container]}>
        <View style={styles.textInput}>
          <TextInput
            multiline
            value={value}
            numberOfLines={2}
            onChangeText={onChangeText}
            maxLength={OTHER_TEXT_MAX_LENGTH}
            underlineColorAndroid="rgba(0,0,0,0)"
            placeholder={option.other_text_placeholder}
            placeholderTextColor={styles._remainingText?.color}
            style={[
              styles.text,
              hasMedia && { flex: 0.6 },
              { textAlign: TEXTALIGN[lang] },
            ]}
          />
          {hasMedia && (
            <View style={styles.mediaTray}>
              <MediaTray
                audio={allow_audio}
                photo={allow_photo}
                video={allow_video}
                enableAudio={onEnableAudio}
                onCapture={onCapture}
              />
            </View>
          )}
        </View>
        <Text style={[styles.remainingText, { textAlign: TEXTALIGN[lang] }]}>
          {OTHER_TEXT_MAX_LENGTH - value.length} characters remaining
        </Text>
      </View>
      {hasMedia && (
        <View style={styles.previewsContainer}>
          <View style={styles.previews}>
            {mediaFiles.map(file => {
              return (
                <MediaPreview
                  key={file.id}
                  media={file}
                  remove={() => removeFile(file.id)}
                />
              );
            })}
          </View>
          {!!mediaFiles.length && (
            <View style={styles.cameraButton}>
              <CameraButton
                photo={allow_photo}
                video={allow_video}
                onCapture={onCapture}
              />
            </View>
          )}
          {audioEnabled && (
            <View style={styles.previews}>
              <AudioButton
                savedClip={audioFile.uri}
                onCapture={onCapture}
                removeFile={() => removeFile(audioFile.id)}
              />
            </View>
          )}
        </View>
      )}
    </>
  );
};

export const OtherText = props => (
  <FullscreenInput component={BaseOtherText} {...props} />
);

const TEXTALIGN = { text: "left", text_urdu: "right" };
